/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArticleType } from './ArticleType';
import { ArticleTypeFromJSON, ArticleTypeFromJSONTyped, ArticleTypeToJSON } from './ArticleType';
import type { FileId } from './FileId';
import { FileIdFromJSON, FileIdFromJSONTyped, FileIdToJSON } from './FileId';
import type { Html } from './Html';
import { HtmlFromJSON, HtmlFromJSONTyped, HtmlToJSON } from './Html';
import type { PublishOn } from './PublishOn';
import { PublishOnFromJSON, PublishOnFromJSONTyped, PublishOnToJSON } from './PublishOn';
import type { Published } from './Published';
import { PublishedFromJSON, PublishedFromJSONTyped, PublishedToJSON } from './Published';

/**
 *
 * @export
 * @interface ArticleCreateModel
 */
export interface ArticleCreateModel {
    /**
     *
     * @type {string}
     * @memberof ArticleCreateModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ArticleCreateModel
     */
    content: string;
    /**
     *
     * @type {Html}
     * @memberof ArticleCreateModel
     */
    html?: Html;
    /**
     *
     * @type {ArticleType}
     * @memberof ArticleCreateModel
     */
    type: ArticleType;
    /**
     *
     * @type {string}
     * @memberof ArticleCreateModel
     */
    author: string;
    /**
     *
     * @type {Published}
     * @memberof ArticleCreateModel
     */
    published?: Published;
    /**
     *
     * @type {PublishOn}
     * @memberof ArticleCreateModel
     */
    publishOn?: PublishOn;
    /**
     *
     * @type {FileId}
     * @memberof ArticleCreateModel
     */
    fileId?: FileId;
    /**
     *
     * @type {string}
     * @memberof ArticleCreateModel
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the ArticleCreateModel interface.
 */
export function instanceOfArticleCreateModel(value: object): boolean {
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    return true;
}

export function ArticleCreateModelFromJSON(json: any): ArticleCreateModel {
    return ArticleCreateModelFromJSONTyped(json, false);
}

export function ArticleCreateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ArticleCreateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'],
        content: json['content'],
        html: json['html'] == null ? undefined : HtmlFromJSON(json['html']),
        type: ArticleTypeFromJSON(json['type']),
        author: json['author'],
        published: json['published'] == null ? undefined : PublishedFromJSON(json['published']),
        publishOn: json['publish_on'] == null ? undefined : PublishOnFromJSON(json['publish_on']),
        fileId: json['file_id'] == null ? undefined : FileIdFromJSON(json['file_id']),
        createdAt: json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function ArticleCreateModelToJSON(value?: ArticleCreateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        content: value['content'],
        html: HtmlToJSON(value['html']),
        type: ArticleTypeToJSON(value['type']),
        author: value['author'],
        published: PublishedToJSON(value['published']),
        publish_on: PublishOnToJSON(value['publishOn']),
        file_id: FileIdToJSON(value['fileId']),
        created_at: value['createdAt'],
    };
}
